import { render, staticRenderFns } from "./SonsMergeInsight.vue?vue&type=template&id=600ed0ba&scoped=true"
import script from "./SonsMergeInsight.vue?vue&type=script&lang=js"
export * from "./SonsMergeInsight.vue?vue&type=script&lang=js"
import style0 from "./SonsMergeInsight.vue?vue&type=style&index=0&id=600ed0ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ed0ba",
  null
  
)

export default component.exports